interface Props {
  selectedDate: string | null
  deadline: string | null | undefined
}

function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(iso))
}

export function DeadlineWarning({ selectedDate, deadline }: Props) {
  if (!selectedDate || !deadline) return null
  if (new Date(selectedDate) <= new Date(deadline)) return null

  return (
    <div className="mx-4 mb-3 flex items-start gap-2 rounded-lg bg-amber-50 border border-amber-200 px-3 py-2.5">
      <span className="text-amber-500 text-base leading-none mt-0.5">⚠</span>
      <p className="text-xs text-amber-800 leading-snug">
        Achtung: Der geplante Termin liegt nach der Abgabefrist ({formatDate(deadline)})
      </p>
    </div>
  )
}
